import { type MouseEvent } from 'react';

import BookmarkIcon from '@cartwhl/ui/icons/BookmarkIcon';

const BOOKMARK_BUTTON_CLASS =
  'border-primary bg-primary hover:bg-secondary flex h-7 w-7 cursor-pointer items-center justify-center rounded-lg border shadow-sm transition-colors';

export interface AssetLibraryCardBookmarkButtonProps {
  visible: boolean;
  isBookmarked: boolean;
  onToggle: () => void;
}

export default function AssetLibraryCardBookmarkButton({
  visible,
  isBookmarked,
  onToggle,
}: AssetLibraryCardBookmarkButtonProps) {
  const showButton = visible || isBookmarked;

  const stopBubble = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <button
      type="button"
      aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
      aria-pressed={isBookmarked}
      className={`${BOOKMARK_BUTTON_CLASS} transition-opacity duration-200 ease-out ${
        showButton ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      onClick={(event) => {
        stopBubble(event);
        onToggle();
      }}
      onMouseDown={stopBubble}
    >
      <BookmarkIcon className="text-primary h-5 w-5" fill={isBookmarked} />
    </button>
  );
}
